import React, { useState, useEffect } from 'react';
import axiosInstance from "../../../interceptor/axiosInstance";
import NotificationService from "../../Utils/NotificationService";

const ShopifyGuide = () => {
  const [orgCode, setOrgCode] = useState('');
  const [copiedSpecific, setCopiedSpecific] = useState(false);
  const [copiedVintage, setCopiedVintage] = useState(false);
  const [copiedAll, setCopiedAll] = useState(false);
  const [copiedProductDesc, setCopiedProductDesc] = useState(false);
  const [copiedProductAll, setCopiedProductAll] = useState(false);

  useEffect(() => {
    const fetchOrgDetails = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setOrgCode("YOUR_ORG_CODE");
        return;
      }
      try {
        const response = await axiosInstance.get(`/org/org-details`);
        const data = response.data[0];
        setOrgCode(data.organisation_code);
      } catch (error) {
        console.error('Error fetching organization details:', error);
        setOrgCode("YOUR_ORG_CODE");
      }
    };
    fetchOrgDetails();
  }, []);

  const fullCode = `<div id="chat-bot-container"></div>\n<script src="https://ezzdesk.com/shared_prompt.js?code=${orgCode}"></script>`;

  const handleCopy = (text, setCopied) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    }).catch((err) => {
      NotificationService.error('Failed to copy text: ' + err);
    });
  };

  const ImagePlaceholder = () => (
    <div style={{
      width: '100%',
      height: '300px',
      backgroundColor: '#f0f0f0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '2px dashed #ccc',
      borderRadius: '8px',
      margin: '20px 0',
      color: '#999',
      fontSize: '18px'
    }}>
      Image Placeholder
    </div>
  );

  return (
    <div style={{
      padding: '40px',
      maxWidth: '800px',
      margin: '0 auto',
      fontFamily: 'Arial, sans-serif',
      background: '#ffffff',
      color: '#333',
      lineHeight: '1.6'
    }}>
      <h1 style={{ fontSize: '28px', marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
        Adding Ezzdesk Widget to Shopify Website
      </h1>
      
      <p style={{ fontSize: '16px', marginBottom: '30px', color: '#555' }}>
        Installing the Ezzdesk widget on your Shopify website is quick and easy! Just copy your widget installation code and follow the steps below based on your Shopify theme architecture.
      </p>

      <div style={{ background: '#e2f0fb', borderLeft: '4px solid #4a90e2', padding: '10px', marginBottom: '30px', fontSize: '14px' }}>
        <strong>Note:</strong> This article covers installation for both <strong>Online Store 2.0</strong> and <strong>Vintage</strong> themes. If you're not sure which theme you're using, check the Shopify free themes page. If your theme is listed there, you're using Online Store 2.0.
      </div>

      <div style={{ marginBottom: '50px' }}>
        <h2 style={{ fontSize: '24px', marginBottom: '20px', color: '#222' }}>Specific Page</h2>
        
        <h3 style={{ fontSize: '20px', marginBottom: '15px', color: '#444' }}>Online Store 2.0</h3>
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          <strong>1. Open your website's visual editor.</strong><br/>
          Log in to your Shopify admin panel and go to <strong>Sales Channels → Online Store</strong>.
        </p>
        <img src="/assets/image_d243f19f.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          Click the <strong>Customize</strong> button:
        </p>
        <img src="/assets/image_52d13876.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>2. Add Custom Liquid section to the target page</strong><br/>
          Select your target page from the dropdown list at the top. Click <strong>Add Section</strong>:
        </p>
        <img src="/assets/file-SucS5kS0pm.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          Then choose <strong>Custom Liquid</strong> from the list:
        </p>
        <img src="/assets/image_c7a30be0.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>3. Paste the installation code</strong><br/>
          Paste the widget installation code to the <strong>Custom Liquid</strong> field and <strong>Save</strong> the changes:
        </p>
        
        <div style={{ position: 'relative', marginBottom: '20px' }}>
          <pre style={{ background: '#f4f4f4', padding: '20px', border: '1px solid #ddd', borderRadius: '5px', fontFamily: 'Courier New, monospace', fontSize: '14px', overflowX: 'auto' }}>
            {fullCode}
          </pre>
          <button onClick={() => handleCopy(fullCode, setCopiedSpecific)} className='btn-color' style={{ position: 'absolute', top: '15px', right: '15px', padding: '6px 16px', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
            {copiedSpecific ? 'Copied!' : 'Copy'}
          </button>
        </div>
        <img src="/assets/image_dc8a1a80.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />



        <h3 style={{ fontSize: '20px', marginBottom: '15px', marginTop: '40px', color: '#444' }}>Vintage Themes</h3>
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          <strong>1. Open your website's visual editor.</strong><br/>
          Go to <strong>Online Store → Themes</strong> and select <strong>Customize</strong>:
        </p>
        <img src="/assets/image_3b50b046.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>2. Add Custom Content section to the target page</strong><br/>
          Select your target page, click <strong>Add Section</strong>:
        </p>
        <img src="/assets/file-oKtL2N0wvq.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          Choose the <strong>Custom Content</strong> section from the list:
        </p>
        <img src="/assets/file-4GfwPNyQCk.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>3. Paste the installation code</strong><br/>
          Remove any extra default blocks from the Custom Content section. Press <strong>Add Block</strong> and choose <strong>Custom HTML</strong>:
        </p>
        <img src="/assets/file-nNa0DSE7BA.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />
        <img src="/assets/image_e475d8ce.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          Paste the widget installation code into the <strong>HTML</strong> field, set <strong>Container width</strong> to 100%, and <strong>Save</strong>:
        </p>
        
        <div style={{ position: 'relative', marginBottom: '20px' }}>
          <pre style={{ background: '#f4f4f4', padding: '20px', border: '1px solid #ddd', borderRadius: '5px', fontFamily: 'Courier New, monospace', fontSize: '14px', overflowX: 'auto' }}>
            {fullCode}
          </pre>
          <button onClick={() => handleCopy(fullCode, setCopiedVintage)} className='btn-color' style={{ position: 'absolute', top: '15px', right: '15px', padding: '6px 16px', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
            {copiedVintage ? 'Copied!' : 'Copy'}
          </button>
        </div>
        <img src="/assets/file-gqDhpAwfaS.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />
        <img src="/assets/image_7a475ab7.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

      </div>

      <div style={{ marginBottom: '50px' }}>
        <h2 style={{ fontSize: '24px', marginBottom: '20px', color: '#222' }}>All Pages</h2>
        
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          <strong>1. Open the Online Store page</strong><br/>
          Go to <strong>Sales Channels → Online Store</strong> (or find it in the left-side menu for Vintage themes). Click on the <strong>...</strong> button and choose <strong>Edit Code</strong>:
        </p>
        <img src="/assets/image_d243f19f.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>2. Open the theme template</strong><br/>
          Select the <strong>theme.liquid</strong> file in the <strong>Layout</strong> section:
        </p>
        <img src="/assets/file-norhJU3GQj.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>3. Paste the installation code</strong><br/>
          Paste the widget installation code before the closing <code>&lt;/body&gt;</code> tag and <strong>Save</strong>:
        </p>

        <div style={{ position: 'relative', marginBottom: '20px' }}>
          <pre style={{ background: '#f4f4f4', padding: '20px', border: '1px solid #ddd', borderRadius: '5px', fontFamily: 'Courier New, monospace', fontSize: '14px', overflowX: 'auto' }}>
            {fullCode}
          </pre>
          <button onClick={() => handleCopy(fullCode, setCopiedAll)} className='btn-color' style={{ position: 'absolute', top: '15px', right: '15px', padding: '6px 16px', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
            {copiedAll ? 'Copied!' : 'Copy'}
          </button>
        </div>
        <img src="/assets/image_f2566002.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

      </div>

      <div style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '24px', marginBottom: '20px', color: '#222' }}>Product Pages</h2>
        
        <h3 style={{ fontSize: '20px', marginBottom: '15px', color: '#444' }}>Adding your widget to the product description</h3>
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          <strong>1. Go to the Products page</strong><br/>
          Go to <strong>Products</strong> and select the product where you’d like to add the widget:
        </p>
        <img src="/assets/file-SZloPCeFET.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>2. Add the widget</strong><br/>
          Get to the HTML editor of the Description by clicking on the <code>&lt;/&gt;</code> icon, paste the installation code there and <strong>Save</strong>:
        </p>

        <div style={{ position: 'relative', marginBottom: '20px' }}>
          <pre style={{ background: '#f4f4f4', padding: '20px', border: '1px solid #ddd', borderRadius: '5px', fontFamily: 'Courier New, monospace', fontSize: '14px', overflowX: 'auto' }}>
            {fullCode}
          </pre>
          <button onClick={() => handleCopy(fullCode, setCopiedProductDesc)} className='btn-color' style={{ position: 'absolute', top: '15px', right: '15px', padding: '6px 16px', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
            {copiedProductDesc ? 'Copied!' : 'Copy'}
          </button>
        </div>
        <img src="/assets/image_e52e9594.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

        <img src="/assets/file-pzNZFUQJgy.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <h3 style={{ fontSize: '20px', marginBottom: '15px', marginTop: '40px', color: '#444' }}>Adding your widget to all product pages</h3>
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          <strong>1. Open the Online Store page</strong><br/>
          Go to <strong>Online Store</strong>, click the <strong>...</strong> button and choose <strong>Edit Code</strong>:
        </p>
        <img src="/assets/image_d243f19f.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />
        <img src="/assets/image_a5f8cf58.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>2. Open the theme template</strong><br/>
          Go to <strong>Sections → main-product.liquid</strong> file:
        </p>
        <img src="/assets/file-57sYMQuW6d.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>3. Paste the installation code</strong><br/>
          Find the place where you want to display the widget, paste the code there, and <strong>Save</strong>:
        </p>

        <div style={{ position: 'relative', marginBottom: '20px' }}>
          <pre style={{ background: '#f4f4f4', padding: '20px', border: '1px solid #ddd', borderRadius: '5px', fontFamily: 'Courier New, monospace', fontSize: '14px', overflowX: 'auto' }}>
            {fullCode}
          </pre>
          <button onClick={() => handleCopy(fullCode, setCopiedProductAll)} className='btn-color' style={{ position: 'absolute', top: '15px', right: '15px', padding: '6px 16px', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
            {copiedProductAll ? 'Copied!' : 'Copy'}
          </button>
        </div>
        <img src="/assets/image_529661d0.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

      </div>

    </div>
  );
};

export default ShopifyGuide;
